module.exports = __webpack_public_path__ + "img/arrow.bbae581c.svg";